import React, { useState } from 'react';
import { TextField, CircularProgress, IconButton, InputAdornment } from "@material-ui/core";
import SearchIcon from "@material-ui/icons/Search";

//API Requests
import { CredentialsService } from '@services';

const SearchEmployee = ({ filteredData, setFilteredData, loading, setLoading, setNoResults, setEmployeeSelected }) => {
    const [isFocused, setIsFocused] = useState(false);
    const [searchValue, setSearchValue] = useState('');

    const onValueChange = (value) => {
        setSearchValue(value);
        setNoResults(false);
    };

    const getEmployeeData = async () => {
        setLoading(true);
        setFilteredData([]);
        setEmployeeSelected(false);
        const data = await CredentialsService.getListOfEmployeeProfiles(null, searchValue);
        if (data && data.length > 0) {
            setFilteredData(data)
        } else {
            setNoResults(true);
        }
        setLoading(false);
    };

    return (
        <>
            <TextField
                variant="outlined"
                placeholder="Search by first name, last name, employee ID or email"
                onChange={(e) =>
                    onValueChange(e.target.value)
                }
                onKeyDown={(e) => {
                    if(e.key === 'Enter') {
                        getEmployeeData();
                        e.preventDefault();
                    }
                }}
                fullWidth={true}
                InputLabelProps={{
                    shrink: true,
                }}
                onFocus={() => setIsFocused(true)}
                onBlur={() => setIsFocused(false)}
                InputProps={{
                    endAdornment: (
                        <InputAdornment position="end">
                            {loading ? 
                                <IconButton>
                                    <CircularProgress color="primary" size={20} />
                                </IconButton> :
                                <IconButton onClick={getEmployeeData}>
                                    <SearchIcon color={isFocused ? "primary": "default"} />
                                </IconButton>
                            }
                        </InputAdornment>
                    ),
                }}
                value={searchValue}
            />
      </>
    )
}

export default SearchEmployee;
